var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-button',{on:{"click":_vm.on_verify}},[_vm._v("实名认证")]),_c('a-button',{on:{"click":_vm.on_verify_status}},[_vm._v("检查认证状态")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }